import Http from "@/common/plugin/Http";
import { appConfig } from '@/appConfig';
/**
 * 通用http请求,后续所有页面由项目组实现跨域访问,不包含nginx转发逻辑
 * 针对不同的业务场景自行封装，封装完成后后续根据
 */
export const http = (() => {
    return new Http(appConfig.axios);
})();